//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CoolLightBox from "vue-cool-lightbox";

export default {
  name: "ProductDocumentItem",
  data() {
    return {
      activeIndexImage: null,
    }
  },

  components: {
    CoolLightBox,
  },

  props: {
    link: {
      type: String,
      default: '',
    },

    title: {
      type: String,
      default: '',
    },
  },

  computed: {
    getExtension() {
      return this.link.split('.').pop();
    },

    setImage() {
      const extension = this.getExtension;
      if (extension === 'png') return this.link;
      if (extension === 'jpg' || extension === 'jpeg') return this.link;
      if (extension === 'pdf') return require("assets/svg/product/pdf-icon.svg");
      if (extension === 'xml') return require("assets/svg/product/xml-icon.svg");
      if (extension === 'doc' ||
        extension === 'docx') return require("assets/svg/product/docx-icon.svg");

      return require("assets/svg/product/docx-icon.svg");
    },

    imagesCoolLightBox() {
      return [this.link];
    },

    isShowGallery() {
      const extension = this.getExtension;
      return extension === 'png' || extension === 'jpg' || extension === 'jpeg';
    }
  },

  methods: {
    openGallery() {
      if (this.isShowGallery) {
        this.activeIndexImage = 0;
        return null;
      }
    }
  },
}
